
<template lang="pug">
.cnmn-confirm(:class="cls")
  table.cnmn-confirm__table
    tbody.cnmn-confirm__tbody
      tr.cnmn-confirm__tr(v-for="[key, value, type] of view")
        th.cnmn-confirm__th {{key}}
        template(v-if="type === 'empty'")
          td.cnmn-confirm__td.cnmn-confirm__td--empty 未入力
        template(v-else-if="type === 'file'")
          td.cnmn-confirm__td {{value.filename}}
        template(v-else-if="type === 'image'")
          td.cnmn-confirm__td: img.cnmn-confirm__img(:src="value.file")
        template(v-else)
          td.cnmn-confirm__td {{value}}

  .cnmn-confirm__action
    cnmn-btn(
      type="button"
      :class="submitting ? 'cnmn-confirm__button-submitting' : 'cnmn-confirm__button-submit'"
      :disabled="submitting"
      @click="onClickSubmit"
    )
      template(v-if="submitting")
        cnmn-icon-loading
        | 送信中...
      template(v-else)
        | 送信

    cnmn-btn.cnmn-confirm__button-cancel(
      v-focus
      type="button"
      @click="onClickCancel"
    ) キャンセル
</template>

<script>
import {isPlainObject} from 'lodash-es'

export default {
  props: {
    model: Object,
    cls: {type: String, default: 'cnmn-confirm--default'},
  },

  data() {
    return {
      submitting: false,
    }
  },

  computed: {
    view() {
      const view = []
      for(const [key, value] of Object.entries(this.model)) {
        if(isPlainObject(value)) {
          if(value.file && value.filename) {
            if(value.filename.match(/\.(gif|jpe?g|png)$/i)) {
              view.push([key, value, 'image'])
              continue
            }
            view.push([key, value, 'file'])
            continue
          }
          view.push([key, '未入力', 'empty'])
          continue
        }

        if(Array.isArray(value)) {
          if(0 < value.length) {
            view.push([key, value.join('、')])
            continue
          }
          view.push([key, '未入力', 'empty'])
          continue
        }

        if(value !== '') {
          view.push([key, value.toString()])
          continue
        }
        view.push([key, '未入力', 'empty'])
      }
      return view
    },
  },

  methods: {
    onClickSubmit() {
      this.submitting = true
      this.$emit('submit', {clearSubmitting: this.clearSubmitting})
    },

    clearSubmitting() {
      this.submitting = false
    },

    onClickCancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="sass">
.cnmn-confirm--default
  background-color: white
  border-radius: 8px
  margin: 20px 0
  max-width: 90vw
  padding: 20px

  .cnmn-confirm__th
    min-width: 10em
    padding: 5px 20px 5px 5px
    text-align: right

  .cnmn-confirm__td
    min-width: 15em
    padding: 5px

  .cnmn-confirm__td--empty
    color: silver

  .cnmn-confirm__action
    display: flex
    justify-content: space-between
    margin-top: 20px

  .cnmn-confirm__button-submit
    background-color: #6060ff
    color: white

  .cnmn-confirm__button-submitting
    background-color: #606060
    color: white

  .cnmn-confirm__button-cancel
    background-color: #e8e8e8
</style>
